
import { DeviceHierarchy } from '@/types/hierarchy';

export const mockHierarchyData: DeviceHierarchy = {
  organizations: [
    {
      id: 'org-001',
      name: 'Department of Defense',
      type: 'military',
      accessLevel: 'top-secret'
    },
    {
      id: 'org-002',
      name: 'Treasury Department',
      type: 'government',
      accessLevel: 'secret'
    },
    {
      id: 'org-003',
      name: 'Acme Corporation',
      type: 'corporate',
      accessLevel: 'confidential'
    }
  ],
  departments: [
    {
      id: 'dept-001',
      name: 'Intelligence Division',
      organizationId: 'org-001',
      accessLevel: 'top-secret'
    },
    {
      id: 'dept-002',
      name: 'Cyber Command',
      organizationId: 'org-001',
      accessLevel: 'secret'
    },
    {
      id: 'dept-003',
      name: 'Logistics',
      organizationId: 'org-001',
      accessLevel: 'confidential'
    },
    {
      id: 'dept-004',
      name: 'Financial Crimes',
      organizationId: 'org-002',
      accessLevel: 'secret'
    },
    {
      id: 'dept-005',
      name: 'IT Department',
      organizationId: 'org-003',
      accessLevel: 'restricted'
    }
  ],
  locations: [
    {
      id: 'loc-001',
      name: 'Pentagon - East Wing',
      departmentId: 'dept-001',
      type: 'area',
      accessLevel: 'top-secret'
    },
    {
      id: 'loc-002',
      name: 'Fort Meade - Building A',
      departmentId: 'dept-002',
      type: 'building',
      accessLevel: 'secret'
    },
    {
      id: 'loc-003',
      name: 'DC Headquarters - 4th Floor',
      departmentId: 'dept-004',
      type: 'floor',
      accessLevel: 'secret'
    },
    {
      id: 'loc-004',
      name: 'Acme Tower - Server Room',
      departmentId: 'dept-005',
      type: 'room',
      accessLevel: 'restricted'
    }
  ]
};

// Extended device data with hierarchy information
export const extendedDeviceData = [
  {
    id: 'DEV001',
    name: 'Command Center Gateway',
    type: 'Gateway',
    status: 'online',
    lastSeen: '2 minutes ago',
    ip: '192.168.1.101',
    location: 'Pentagon - East Wing',
    locationId: 'loc-001',
    departmentId: 'dept-001',
    organizationId: 'org-001',
    accessLevel: 'top-secret',
    user: 'John Doe'
  },
  {
    id: 'DEV002',
    name: 'Secure Comms Hub',
    type: 'Gateway',
    status: 'online',
    lastSeen: '5 minutes ago',
    ip: '192.168.1.102',
    location: 'Fort Meade - Building A',
    locationId: 'loc-002',
    departmentId: 'dept-002',
    organizationId: 'org-001',
    accessLevel: 'secret',
    user: 'Emma Smith'
  },
  {
    id: 'DEV003',
    name: 'Financial Data Sensor',
    type: 'Sensor',
    status: 'offline',
    lastSeen: '3 hours ago',
    ip: '192.168.1.103',
    location: 'DC Headquarters - 4th Floor',
    locationId: 'loc-003',
    departmentId: 'dept-004',
    organizationId: 'org-002',
    accessLevel: 'confidential',
    user: 'John Doe'
  },
  {
    id: 'DEV004',
    name: 'Server Room Monitor',
    type: 'Sensor',
    status: 'warning',
    lastSeen: '10 minutes ago',
    ip: '192.168.1.104',
    location: 'Acme Tower - Server Room',
    locationId: 'loc-004',
    departmentId: 'dept-005',
    organizationId: 'org-003',
    accessLevel: 'restricted',
    user: 'Alice Johnson'
  },
  {
    id: 'DEV005',
    name: 'Logistics Tracker',
    type: 'Actuator',
    status: 'online',
    lastSeen: '1 minute ago',
    ip: '192.168.1.105',
    location: 'Pentagon - East Wing',
    locationId: 'loc-001',
    departmentId: 'dept-003',
    organizationId: 'org-001',
    accessLevel: 'unclassified',
    user: 'Bob Wilson'
  }
];
